import { ItemShop } from 'actions/actionTypes';

export const loadItemShopListRequest = () => ({ type: ItemShop.LOAD_ITEM_SHOP_LIST_REQUEST });
export const loadItemShopListSuccess = (responseData) => ({ type: ItemShop.LOAD_ITEM_SHOP_LIST_SUCCESS, payload: responseData });
export const loadItemShopListFailure = (errorMessage) => ({ type: ItemShop.LOAD_ITEM_SHOP_LIST_FAILURE, payload: errorMessage });